import React from "react";
import {Section} from "../../../../../elements/section/Section";
import {CustomSwitchFieldWithTitle} from "../../../../../elements/customSwitchFieldWithTitle/CustomSwitchFieldWithTitle";
import {useAppDispatch} from "../../../../../../app/hooks";
import {updateSettings, selectSearchNearestByPostcode} from "../toolSettingsSlice";
import {DisabledField, isFieldDisabled} from "../../../assistantPreset";
import {BotType} from "../../../../../../api/generated";

interface VehicleSearchSettingsProps {
    botType: BotType;
}

export const VehicleSearchSettings: React.FC<VehicleSearchSettingsProps> = ({botType}) => {
    const dispatch = useAppDispatch();
    const disabled = isFieldDisabled(DisabledField.VEHICLE_INFO, botType);

    return (
        <Section title="Vehicle Search">
            <CustomSwitchFieldWithTitle
                textOnTrue={"Yes"}
                textOnFalse={"No"}
                title={"Search Nearest By Postcode Enabled"}
                description={"Allow searching for nearest vehicles by postcode"}
                valueSelector={selectSearchNearestByPostcode}
                toggleValue={(v) => dispatch(updateSettings({searchNearestByPostcodeEnabled: v}))}
                disabled={disabled}
            />
        </Section>
    );
};

